import type { FC } from 'react'

import { TagColor as Color, Tag } from '@factorialco/deprecated-design-system'

import createMemo from 'modules/core/hooks/createMemo'

interface Props {
  children: string
  color?: Color
}

const createColor = createMemo((children: string) => {
  if (!children) return

  const tagInfoColors: Record<string, Color> = {
    viridian: Color.viridian,
    radical: Color.radical,
    malibu: Color.malibu,
    lime: Color.lime,
    purple: Color.purple,
    champagne: Color.champagne,
  }

  const colorKeys = Object.keys(tagInfoColors)
  const colorVals = tagInfoColors
  let hash = 0

  if (children === undefined || children.length === 0) {
    return colorVals[colorKeys[0] ?? '']
  }

  for (let i = 0; i < children.length; i++) {
    hash = children.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }

  hash = ((hash % colorKeys.length) + colorKeys.length) % colorKeys.length

  return colorVals[colorKeys[hash] ?? '']
})

const ColoredTag: FC<Props> = ({ children, color }) => {
  const type = color || createColor(children)

  return <Tag type={type}>{children}</Tag>
}

export default ColoredTag
